/* CHOMP quiz — "Find your dog's ten-second routine".

   Lifted from vault P-05 (screen state machine, endowed progress, back button,
   progressbar semantics) and re-derived for CHOMP: an 11-question bank instead
   of three hardcoded steps, the brand's own tokens, and a result that is the
   REAL buy box driven through window.CHOMP — live price in the visitor's market
   currency, the live Loop plan, the real cart drawer. research/quiz.md explains
   why each question exists; one that changes neither the pick nor the copy
   should be cut, not kept.

   Deliberately absent: a "% match" score (P-05's demo invents one), a discount
   code (the store has none), any claim that a wipe treats anything. */
(function () {
  'use strict';

  var QUIZ_ID = 'dental-v1';
  var KLAVIYO = { company: 'QZKK9g', list: 'V6YigW' };  // public site key; newsletter list, single opt-in
  var ENDOW = 12;                                        // endowed progress: the bar starts part-filled
  var SIX_WEEKS = 42;                                    // smallest supply worth recommending

  var BANK = [
    { id: 'name', type: 'text', q: 'First — who is this for?', ph: "Your dog's name" },
    { id: 'size', q: 'How big is {name}?', opts: [
      ['toy', 'Toy', 'under 5 kg'], ['small', 'Small', '5–10 kg'],
      ['medium', 'Medium', '10–25 kg'], ['large', 'Large', '25 kg and up']] },
    { id: 'age', q: 'How old is {name}?', opts: [
      ['puppy', 'Puppy', 'under a year'], ['adult', 'Adult', '1 to 7 years'], ['senior', 'Senior', '7 and up']] },
    { id: 'dogs', q: 'How many dogs are in the house?', opts: [
      ['1', 'Just {name}', ''], ['2', 'Two', ''], ['3', 'Three or more', '']] },
    { id: 'routine', q: "What is {name}'s teeth routine right now?", opts: [
      ['none', 'Nothing yet', ''], ['chews', 'Dental chews or treats', ''], ['additive', 'A water additive', ''],
      ['stopped', 'We brushed, then stopped', ''], ['brush', 'We brush most days', '']] },
    { id: 'handling', q: 'How does {name} feel about a hand near their mouth?', opts: [
      ['happy', 'Happy to let me', ''], ['tolerates', 'Puts up with it for a few seconds', ''],
      ['pulls', 'Pulls away', ''], ['wont', 'Nobody gets near it', '']] },
    { id: 'breath', q: 'When {name} yawns in your face, what happens?', opts: [
      ['fine', 'Nothing much', ''], ['notice', 'I notice it', ''], ['leave', 'I leave the room', '']] },
    { id: 'pb', q: 'How does {name} feel about peanut butter?', opts: [
      ['obsessed', 'Would sell me for it', ''], ['likes', 'Likes it', ''],
      ['meh', 'Not bothered', ''], ['avoid', 'We avoid it', 'allergy or vet advice']] },
    { id: 'tastes', q: 'How does {name} handle new smells and tastes?', opts: [
      ['anything', 'Eats anything', ''], ['sniffs', 'Sniffs first, then decides', ''], ['suspicious', 'Very suspicious', '']] },
    { id: 'freq', q: 'Realistically, how often can you do ten seconds of teeth?', opts: [
      ['7', 'Every day', ''], ['5', 'Most days', ''], ['3', 'A few times a week', '']] },
    { id: 'flags', type: 'multi', q: 'Last one. Have you noticed any of these?', note: 'Pick any that apply.', opts: [
      ['bleed', 'Gums that bleed', ''], ['swollen', 'Red or swollen gums', ''],
      ['tooth', 'A loose or broken tooth', ''], ['pain', 'Off their food, or seems in pain', ''],
      ['none', 'None of these', '']] }
  ];

  var root = document.getElementById('quiz');
  if (!root) return;
  var $ = function (sel) { return root.querySelector(sel); };
  var screens = { intro: $('[data-screen="intro"]'), q: $('[data-screen="q"]'),
                  gate: $('[data-screen="gate"]'), result: $('[data-screen="result"]') };
  var progress = $('.qz-progress'), track = $('.qz-track'), bar = $('.qz-bar'), stepLbl = $('.qz-step');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var st = { i: 0, a: {}, name: '', rec: null, started: false };

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // user input only ever lands via textContent
    return n;
  }
  function dog() { return st.name || 'your dog'; }
  function Dog() { return st.name || 'Your dog'; }
  function fill(s) { return s.replace(/\{name\}/g, dog()); }
  function cleanName(v) {
    return (v || '').replace(/[^\p{L}\p{N} '’.-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 24);
  }
  function publish(name, data) {
    data = data || {}; data.quiz = QUIZ_ID;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  var onShopify = function () { return !!(window.Shopify && window.Shopify.routes); };

  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = k !== name; });
    progress.hidden = name === 'intro' || name === 'result';
    root.setAttribute('data-at', name);
    if (!reduced) {
      screens[name].classList.remove('qz-in');
      void screens[name].offsetWidth;          // forced reflow, not rAF: a hidden document never paints
      screens[name].classList.add('qz-in');
    }
    var h = screens[name].querySelector('[data-focus]');
    if (h) h.focus({ preventScroll: true });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 16;
    if (window.pageYOffset > top) window.scrollTo(0, top);
  }

  function setProgress(answered) {
    var total = BANK.length;
    var pct = answered >= total ? 100 : ENDOW + (100 - ENDOW) * (answered / total);
    bar.style.width = pct + '%';
    track.setAttribute('aria-valuenow', String(Math.round(pct)));
    stepLbl.textContent = answered < total ? 'Question ' + (answered + 1) + ' of ' + total : 'Nearly there';
  }

  /* ---------- questions ---------- */
  function renderQ(i) {
    var q = BANK[i], host = screens.q;
    host.textContent = '';
    var h = el('h2', 'qz-h', fill(q.q));
    h.id = 'qzQ'; h.tabIndex = -1; h.setAttribute('data-focus', '');
    host.appendChild(h);
    if (q.note) host.appendChild(el('p', 'qz-note', q.note));

    if (q.type === 'text') {
      var f = el('form', 'qz-text');
      var inp = el('input'); inp.type = 'text'; inp.id = 'qzName'; inp.maxLength = 24;
      inp.placeholder = q.ph; inp.autocomplete = 'off'; inp.setAttribute('aria-labelledby', 'qzQ');
      inp.value = st.name;
      var go = el('button', 'btn btn-lg', 'Continue'); go.type = 'submit';
      f.appendChild(inp); f.appendChild(go);
      f.addEventListener('submit', function (e) { e.preventDefault(); answer(i, cleanName(inp.value)); });
      host.appendChild(f);
      var sk = el('button', 'qz-link', 'Skip'); sk.type = 'button';
      sk.addEventListener('click', function () { answer(i, ''); });
      host.appendChild(sk);
    } else {
      var multi = q.type === 'multi';
      var picked = multi ? (st.a[q.id] || []).slice() : null;
      var grp = el('div', 'qz-opts'); grp.setAttribute('role', 'group'); grp.setAttribute('aria-labelledby', 'qzQ');
      q.opts.forEach(function (o, n) {
        var b = el('button', 'qz-opt'); b.type = 'button'; b.setAttribute('data-v', o[0]);
        var on = multi ? picked.indexOf(o[0]) > -1 : st.a[q.id] === o[0];
        b.setAttribute('aria-pressed', String(on));
        var k = el('span', 'qz-key', String(n + 1)); k.setAttribute('aria-hidden', 'true');
        var t = el('span', 'qz-opt-txt'); t.appendChild(el('b', null, fill(o[1])));
        if (o[2]) t.appendChild(el('small', null, o[2]));
        b.appendChild(k); b.appendChild(t);
        b.addEventListener('click', function () {
          if (!multi) {
            b.setAttribute('aria-pressed', 'true');
            setTimeout(function () { answer(i, o[0]); }, reduced ? 0 : 160);
            return;
          }
          var idx = picked.indexOf(o[0]);
          if (o[0] === 'none') picked = idx > -1 ? [] : ['none'];
          else {
            picked = picked.filter(function (v) { return v !== 'none'; });
            if (idx > -1) picked.splice(idx, 1); else picked.push(o[0]);
          }
          grp.querySelectorAll('.qz-opt').forEach(function (x) {
            x.setAttribute('aria-pressed', String(picked.indexOf(x.getAttribute('data-v')) > -1));
          });
          cont.disabled = !picked.length;
        });
        grp.appendChild(b);
      });
      host.appendChild(grp);
      if (multi) {
        var cont = el('button', 'btn btn-lg qz-continue', 'See my routine'); cont.type = 'button';
        cont.disabled = !picked.length;
        cont.addEventListener('click', function () { answer(i, picked.slice()); });
        host.appendChild(cont);
      }
    }
    var back = el('button', 'qz-back', '← Back'); back.type = 'button';
    back.addEventListener('click', function () { if (i === 0) show('intro'); else go(i - 1); });
    host.appendChild(back);
  }

  function go(i) { st.i = i; renderQ(i); setProgress(i); show('q'); }

  function answer(i, v) {
    var q = BANK[i];
    if (q.id === 'name') st.name = v; else st.a[q.id] = v;
    publish('question_' + (i + 1), { question: q.id, answer: q.id === 'name' ? (v ? 'given' : 'skipped') : [].concat(v).join(',') });
    if (i + 1 < BANK.length) go(i + 1);
    else toGate();
  }

  /* keyboard: number keys pick an option on single-select screens */
  document.addEventListener('keydown', function (e) {
    if (screens.q.hidden || e.altKey || e.ctrlKey || e.metaKey) return;
    if (/^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '')) return;
    var n = parseInt(e.key, 10);
    if (!n) return;
    var opt = screens.q.querySelectorAll('.qz-opt')[n - 1];
    if (opt) { e.preventDefault(); opt.click(); }
  });

  /* ---------- recommendation: real SKUs, deterministic, explainable ---------- */
  function recommend(a) {
    var C = window.CHOMP || {}, U = C.unitsPerCan || 50, PER = C.perDay || 2;
    var dogs = parseInt(a.dogs, 10) || 1;
    var perDay = dogs * ((parseInt(a.freq, 10) || 7) / 7) * PER;     // household wipes per day
    var packs = [1, 2, 3].map(function (c) { return { id: 't' + c, cans: c, days: Math.round(c * U / perDay) }; });
    var pick = packs.filter(function (p) { return p.days >= SIX_WEEKS; })[0] || packs[2];
    /* Loop's cadence per pack is built for ONE dog, daily (25/50/75 days). */
    var cadence = pick.cans * U / PER, ratio = pick.days / cadence;
    var plan = ratio >= 0.55 && ratio <= 1.45 ? 'sub' : 'otp';

    var s = { minty: 0, pb: 0, plain: 0 };
    if (a.breath === 'leave') s.minty += 2; else if (a.breath === 'notice') s.minty += 1;
    if (a.pb === 'obsessed') s.pb += 3; else if (a.pb === 'likes') s.pb += 2;
    if (a.tastes === 'anything') s.minty += 1;
    else if (a.tastes === 'sniffs') s.pb += 1;
    else if (a.tastes === 'suspicious') { s.plain += 2; s.pb += 1; }
    if (a.handling === 'pulls' || a.handling === 'wont') s.pb += 1;
    if (a.pb === 'avoid') s.pb = -99;
    var flavor = ['minty', 'pb', 'plain'].reduce(function (b, k) { return s[k] > s[b] ? k : b; }, 'minty');

    return { tier: pick.id, cans: pick.cans, days: pick.days, cadence: Math.round(cadence),
             ratio: ratio, plan: plan, flavor: flavor, dogs: dogs,
             flags: (a.flags || []).filter(function (f) { return f !== 'none'; }) };
  }

  function weeks(days) { var w = Math.round(days / 7); return w + (w === 1 ? ' week' : ' weeks'); }

  function reasons(r, a) {
    var out = [], fname = (window.CHOMP && CHOMP.flavorName(r.flavor)) || r.flavor;
    if (r.flavor === 'pb') out.push(a.pb === 'obsessed' || a.pb === 'likes'
      ? 'Peanut Butter, so the first few goes taste of something ' + dog() + ' already loves.'
      : 'Peanut Butter: a flavour ' + dog() + ' already trusts makes a hand near the mouth an easier sell.');
    else if (r.flavor === 'plain') out.push(a.pb === 'avoid'
      ? "Unscented, and no Peanut Butter. The full ingredient list is printed on the tub — check it against anything your vet has flagged."
      : 'Unscented: nothing new for a suspicious nose to object to.');
    else out.push(a.breath === 'leave' || a.breath === 'notice'
      ? 'You said the yawns are noticeable. ' + fname + ' goes after the smell, and the film that causes it.'
      : fname + ': cool, clean, and the simplest place to start.');

    var who = r.dogs > 1 ? 'your ' + r.dogs + ' dogs' : dog();
    var packTxt = r.cans + (r.cans > 1 ? ' tubs' : ' tub') + ' last about ' + r.days + ' days for ' + who + ' at your pace';
    if (r.plan === 'sub') {
      var cw = weeks(r.cadence);
      out.push(r.ratio > 1.15 ? packTxt + '. The plan ships every ' + cw + ', so push the next box back a little from your account.'
             : r.ratio < 0.85 ? packTxt + '. The plan ships every ' + cw + ', so bring the next box forward from your account.'
             : packTxt + ', and the plan ships the next ' + (r.cans > 1 ? 'set' : 'tub') + ' right when it runs out.');
    } else {
      out.push(r.ratio > 1.45
        ? packTxt + ' — longer than the subscription schedule, so buy as you go instead of letting tubs pile up.'
        : packTxt + '. Subscriptions ship on a one-dog schedule, so buy as you go — or subscribe and bring each box forward.');
    }

    var map = {
      chews: 'Chews are fine as a treat, but nothing presses on the gum line like your own finger.',
      additive: 'A water additive never touches the teeth. A wipe does, and you can see on the cloth what came off.',
      stopped: 'You tried brushing and stopped. This is the same job without the wrestling: a wipe on your finger.',
      brush: 'If brushing works, keep brushing — it is the most thorough clean there is. Wipes are for the nights it does not happen.',
      none: 'Starting from nothing is fine. Ten seconds after dinner is the whole routine.'
    };
    if (a.handling === 'pulls' || a.handling === 'wont')
      out.push('Go slowly: a few days of letting ' + dog() + ' lick the wipe, then the front teeth only, then work back. A treat after, every time.');
    else if (a.size === 'toy' || a.size === 'small')
      out.push('Small mouth? A finger fits where a brush does not.');
    else if (map[a.routine]) out.push(map[a.routine]);
    return out;
  }

  /* ---------- email gate: soft, before the result, visible skip ---------- */
  function toGate() {
    st.rec = recommend(st.a);
    setProgress(BANK.length);
    screens.gate.querySelector('[data-g-title]').textContent = Dog() + "'s routine is ready.";
    show('gate');
  }

  function subscribe(email) {
    var r = st.rec, a = st.a;
    var props = { quiz: QUIZ_ID, quiz_dog_name: st.name, quiz_size: a.size, quiz_age: a.age, quiz_dogs: a.dogs,
      quiz_routine: a.routine, quiz_handling: a.handling, quiz_breath: a.breath, quiz_pb: a.pb,
      quiz_tastes: a.tastes, quiz_frequency: a.freq, quiz_flags: (a.flags || []).join(','),
      quiz_rec_flavor: r.flavor, quiz_rec_pack: r.cans, quiz_rec_plan: r.plan };
    if (!onShopify()) {               // local preview: never write to the live list
      console.info('CHOMP quiz (preview) — would subscribe', email, props);
      return Promise.resolve();
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO.company, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-10-15' },
      body: JSON.stringify({ data: { type: 'subscription',
        attributes: { custom_source: 'CHOMP quiz', profile: { data: { type: 'profile',
          attributes: { email: email, properties: props } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO.list } } } } })
    }).then(function (res) { if (!res.ok) throw new Error('Klaviyo ' + res.status); });
  }

  var form = screens.gate.querySelector('form'), email = form.querySelector('input[type="email"]');
  var err = screens.gate.querySelector('.qz-err'), sendBtn = form.querySelector('button[type="submit"]');
  email.addEventListener('blur', function () { if (email.value) validate(); });
  function validate() {
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim());
    email.setAttribute('aria-invalid', String(!ok));
    err.hidden = ok;
    if (!ok) err.textContent = 'Enter an email like name@example.com — or skip and see the result.';
    return ok;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate()) { email.focus(); return; }
    sendBtn.disabled = true; sendBtn.textContent = 'Saving…';
    subscribe(email.value.trim())
      .then(function () { publish('email_submit', {}); showResult(''); })
      .catch(function (x) {
        console.warn('CHOMP quiz:', x.message);
        showResult('We could not save your email just now — the footer signup works any time.');
      })
      .then(function () { sendBtn.disabled = false; sendBtn.textContent = 'Email me, then show my result'; });
  });
  screens.gate.querySelector('[data-qz-skip]').addEventListener('click', function () { showResult(''); });

  /* ---------- result: the real buy box, positioned by the quiz ---------- */
  function tagCart(r) {
    if (!onShopify()) return;
    fetch((Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { _quiz: QUIZ_ID, _quiz_result: r.flavor + '/' + r.cans + '/' + r.plan } })
    }).then(function (res) { if (!res.ok) throw new Error('cart attributes ' + res.status); })
      .catch(function (x) { console.warn('CHOMP quiz:', x.message); });
  }

  function showResult(notice) {
    var r = st.rec || recommend(st.a), R = screens.result;
    st.rec = r;
    var fname = (window.CHOMP && CHOMP.flavorName(r.flavor)) || r.flavor;
    R.querySelector('[data-r-vet]').hidden = !r.flags.length;
    R.querySelector('[data-r-kicker]').textContent = r.flags.length ? 'Vet first, then this' : Dog() + "'s routine";
    R.querySelector('[data-r-title]').textContent =
      fname + ', ' + r.cans + (r.cans > 1 ? ' tubs' : ' tub') + (r.plan === 'sub' ? ', subscribed' : '');
    R.querySelector('[data-r-sub]').textContent = 'About ' + r.days + ' days at your pace' +
      (r.flags.length ? ' — for after the check-up.' : '.');
    var ul = R.querySelector('[data-r-why]'); ul.textContent = '';
    reasons(r, st.a).forEach(function (t) { ul.appendChild(el('li', null, t)); });
    var note = R.querySelector('[data-r-notice]'); note.hidden = !notice; note.textContent = notice || '';

    var single = R.querySelector('[data-qz-single]'); single.hidden = r.tier === 't1';

    if (window.CHOMP) CHOMP.select({ flavor: r.flavor, plan: r.plan, tier: r.tier });
    var tiers = R.querySelector('#tiers');
    if (tiers) {
      tiers.setAttribute('data-rec', r.tier);
      tiers.style.setProperty('--rec-label', JSON.stringify('For ' + (st.name || 'you')));
    }
    show('result');
    publish('result_view', { flavor: r.flavor, pack: r.cans, plan: r.plan, dogs: r.dogs, vet_first: r.flags.length > 0 });
    tagCart(r);
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-qz-start]')) {
      if (!st.started) { st.started = true; publish('quiz_start', {}); }
      go(0);
    } else if (e.target.closest('[data-qz-restart]')) {
      st = { i: 0, a: {}, name: '', rec: null, started: true };
      show('intro');
    } else if (e.target.closest('[data-qz-single]')) {
      if (window.CHOMP) CHOMP.select({ tier: 't1' });
      e.target.closest('[data-qz-single]').hidden = true;
    } else if (e.target.closest('#mainAtc') && st.rec) {
      publish('atc_from_quiz', { flavor: st.rec.flavor, pack: st.rec.cans, plan: st.rec.plan });
    }
  });
  screens.gate.querySelector('.qz-back').addEventListener('click', function () { go(BANK.length - 1); });

  root.classList.add('qz-ready');
})();
